import Service from '../notice-modular-service';
import Pagination from '@/components/pagination/index.vue';
export default {
  components: {
    Pagination
  },
  data () {
    return {
      detailInfo: {}
    };
  },
  created () {
    // Service.getGovAssetDict('CODE');
    this.getDetail(this.$route.query.id);
  },
  computed: {
  },
  methods: {
    getDetail (id) {
      Service.getMortgageDetail(id).then(res => {
        this.detailInfo = res.data;
      });
    },

    handdle(row) {
      this.$router.push('/notice-modular/mortgageDetail?id=' + row.id);
    }
  }
};
